import { getAssetManifest, loadAssetManifest, onAssetManifestChange } from '@sorrem/engine';
import type { AssetManifest } from '@sorrem/shared';
import { useEffect, useSyncExternalStore } from 'react';

/**
 * The page's asset manifest (#285): the copy remembered from the last visit
 * at first (see `seedAssetManifest`), then the server's, loading it if no
 * one has yet; null before either. Re-renders whenever it changes, so a
 * component's versioned asset URLs follow it.
 */
export function useAssetManifest(): AssetManifest | null {
    useEffect(() => {
        void loadAssetManifest();
    }, []);
    return useSyncExternalStore(onAssetManifestChange, getAssetManifest);
}
